import Delegate from '//www.ohmycream.com/cdn/shop/t/168/assets/ftdomdelegate.min.js?v=167457923630348017651677856387';

/**
 * Reviews
 *
 * We are using JudgeMe. While powerful, the markup is pretty rigid and make it hard for us to properly style it. So we are
 * re-ordering elements to something that is easier to use for us.
 */
export class ProductPageReviews extends HTMLElement {
  connectedCallback() {

    let that = this;
    setTimeout(function () {
      that._visualUpdate();
    }, 2000);

    if (window.shop.judgeMeConcerns) {
      this._manageJudgeMeConcerns()
    }

    if (window.shop.yotpo && window.shop.yotpo.active && window.shop.yotpo.activeLinks) {
      this._manageReferralPopin()
    }

    this._attachListeners();
  }

  _attachListeners() {
    new Delegate(document.body).on('click', '.jdgm-prev-badge__text', this._scrollToReviews.bind(this));
    new Delegate(this).on('click', '.jdgm-paginate__page', this._sendPaginateEvent.bind(this));
    new Delegate(document.body).on('click', '[data-action="close-product-referral-popin"]', this._closeProductReferralPopin.bind(this));
  }

  _visualUpdate() {
    // This is a hack to force removing built in JudgeMe styles
    var judgemeStylesInterval = setInterval(function () {
      if ($('.jdgm-miracle-styles').remove().length === 0) {
        clearInterval(judgemeStylesInterval);
      }
    }, 150);

    // update each review layout
    let notUkReviewsCount = 0;
    $(document).arrive('.jdgm-rev', { existing: true }, function () {
      let review = $(this),
        body = review.find('.jdgm-rev__body'),
        title = review.find('.jdgm-rev__title'),
        timestamp = review.find('.jdgm-rev__timestamp'),
        reviewerName = review.find('.jdgm-rev__author-wrapper'),
        reviewerConcern = review.find('.jdgm-rev__concern'),
        newTimestamp = timestamp.text().split('/'),
        newTimeText = 'Le ' + newTimestamp[1] + '/' + newTimestamp[0] + '/' + newTimestamp[2];

      if (title) {
        title.addClass('smallcaps-m');
        title.addClass('sm:smallcaps-xs');
      }
      if (body) {
        body.addClass('text-m');
      }
      if (reviewerName) {
        reviewerName.addClass('smallcaps-m');
        reviewerName.addClass('sm:smallcaps-xs');
      }
      if (reviewerConcern) {
        reviewerConcern.addClass('smallcaps-m');
        reviewerConcern.addClass('sm:smallcaps-xs');
      }
      if (timestamp) {
        timestamp.addClass('smallcaps-m');
        timestamp.addClass('sm:smallcaps-xs');
      }

      // patch temporaire en attendant les reviews UK
      if (window.shop.storeCountryConfig === 'uk') {
        let reviewUrl = review.attr('data-product-url');
        if (window.location.pathname.indexOf(reviewUrl) < 0) {
          review.addClass('hidden');
          notUkReviewsCount++
        }
        if (notUkReviewsCount === 5) {
          $('.jdgm-paginate').addClass('hidden');
        }
      }

      timestamp.text(newTimeText).insertAfter(body);
      reviewerName.insertAfter(body);

      if (window.shop.judgeMeConcerns) {
        if (body[0].innerText.split(' Concern:').length > 1) {
          let concern = body[0].innerText.split(' Concern:')[1];
          let span = document.createElement('span');
          span.classList.add('jdgm-rev__concern');
          span.innerText = window.shop.judgeMeConcerns.prefix + ' : ' + concern;

          reviewerName.after(span);
        }

        body[0].innerText = body[0].innerText.split(' Concern:')[0];
      }
    });

    $(document).arrive('.jdgm-widget-actions-wrapper a', { existing: true }, function () {
      $(this).on('click', function () {
        if ($(this).attr('aria-expanded') === 'false') {
          $(document).trigger('gtm.customEvent', [{ event: 'writeReviewCTA' }]);
        }
      });
    });

  }

  _scrollToReviews(event, target) {
    event.preventDefault();

    let that = this;
    // scroll to reviews
    let reviewsOffset = $('#reviews-section').offset().top;
    $('html, body').animate({
      scrollTop: that._getReviewsOffset(reviewsOffset)
    }, 1000);
    return false;
  }

  // get reviews offset for scroll
  _getReviewsOffset(reviewsOffset) {
    if (window.matchMedia('(max-width: 560px)').matches) {
      reviewsOffset -= 70;
    } else {
      reviewsOffset -= 140;
    }
    return reviewsOffset;
  }

  _manageJudgeMeConcerns() {
    let div = document.createElement('div');
    let select = document.createElement('select');
    let selectedConcern = '';

    div.classList.add('jdgm-form__concern-fieldset');
    div.innerHTML = '<svg class="icon icon-dropdown-arrow" viewBox="0 0 53 32"><path d="M49.857 7.21l-21.125 21.408c-0.515 0.515-1.243 0.778-2.051 0.74-1.059 0.038-1.787-0.225-2.315-0.753l-21.113-21.395c-1.069-1.074-1.069-2.806-0.008-3.873 1.057-1.060 2.773-1.060 3.832 0.002l19.477 19.424 19.472-19.419c1.064-1.067 2.78-1.067 3.84-0.005 1.063 1.066 1.063 2.794 0 3.86l-0.010 0.010z"></path></svg>' +
      '<label for="jdgm_review_concern">' + window.shop.judgeMeConcerns.prefix + '</label>';

    select.id = 'jdgm_review_concern';
    select.name = "reviewer_concern";

    // Append select placeholder
    let selectPlaceholder = document.createElement('option');
    selectPlaceholder.value = '';
    selectPlaceholder.disabled = true;
    selectPlaceholder.selected = true;
    selectPlaceholder.text = window.shop.judgeMeConcerns.placeholder

    select.append(selectPlaceholder);

    for (let concern in window.shop.judgeMeConcerns.concerns) {
      let option = document.createElement('option');

      option.value = concern;

      if (window.shop.judgeMeConcerns.concerns.hasOwnProperty(concern)) {
        option.text = window.shop.judgeMeConcerns.concerns[concern];
      }

      select.append(option);
    }

    div.append(select);

    // Append concern select in judgeme form
    $(document).arrive('.jdgm-form', { existing: true }, function () {
      let emailInputContainer = document.querySelector('.jdgm-form__email-fieldset');

      if (emailInputContainer) {
        emailInputContainer.after(div);
      }

      this.addEventListener('submit', function () {
        if (selectedConcern !== '') {
          if (window.shop.judgeMeConcerns.concerns.hasOwnProperty(selectedConcern)) {
            let concern = window.shop.judgeMeConcerns.concerns[selectedConcern];
            let bodyInput = this.querySelector('textarea[name="review_body"]');

            if (bodyInput) {
              if (bodyInput.value !== '') {
                bodyInput.value = bodyInput.value + ' Concern:' + concern;
              }
            }
          }
        }
      })
    })

    // Get concern select value
    $(document).arrive('select[name="reviewer_concern"]', { existing: true }, function () {
      this.addEventListener('change', function () {
        selectedConcern = this.value;
      })
    })
  }

  _sendPaginateEvent() {
    // send GTM event when click en jdgm pagination
    $(document).trigger('gtm.customEvent', [{ event: 'seeNextReviewsCTA' }]);
  }

  _manageReferralPopin() {
    $(document).arrive('.jdgm-notification', { existing: true }, function () {
      if (parseInt($('.jdgm-form input[name="score"]').val()) >= 4) {
        setTimeout(function () {
          $('#product-referral-popin, .product-referral-popin__overlay').addClass('active');
        }, 2000)
      }
    });
  }

  _closeProductReferralPopin(event, target) {
    event.preventDefault();
    $('#product-referral-popin, .product-referral-popin__overlay').removeClass('active');
  }
}

try {
  window.customElements.define('product-reviews', ProductPageReviews);
} catch (e) { }